export default __webpack_public_path__ + "static/nureinberg-43cfd973cf74b44ebd5b0d0015307492.mp4";